var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _g, _path172, _path173, _path174, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessionalImg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 100,
    viewBox: "0 0 112 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.0476 79.3544C68.9586 79.3544 68.8685 79.3311 68.7886 79.2846L48.7857 67.7358C48.6258 67.6437 48.5266 67.4727 48.5266 67.2885C48.5266 67.1033 48.6248 66.9323 48.7847 66.8392L68.653 55.2935C68.8118 55.2004 69.0112 55.2004 69.1721 55.2935L89.175 66.8412C89.3349 66.9333 89.434 67.1043 89.434 67.2885C89.434 67.4737 89.3359 67.6447 89.176 67.7378L69.3077 79.2846C69.2278 79.3311 69.1377 79.3544 69.0476 79.3544ZM50.078 67.2865L69.0466 78.2372L87.8817 67.2905L68.914 56.3409L50.078 67.2865Z",
    fill: "#4C5C75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8485 55.335L88.8257 63.854L68.9575 75.4001L68.9803 66.8811L88.8485 55.335Z",
    fill: "#7F1767"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9805 66.8804L68.9577 75.3994L48.9553 63.8511L48.9781 55.332L68.9805 66.8804Z",
    fill: "#963880"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8486 55.3326L68.9804 66.8787L48.978 55.3303L68.8462 43.7842L88.8486 55.3326Z",
    fill: "#7F1767"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9133 55.326L68.8494 46.0645L84.9133 55.3391L68.9772 64.6003L52.9133 55.326Z",
    fill: "#7E5AF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5144 62.3818L82.5169 63.2698L77.9791 65.8897L77.9766 65.0017L82.5144 62.3818Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5095 60.6758L82.512 61.5637L77.9742 64.1836L77.9717 63.2957L82.5095 60.6758Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5193 64.083L82.5218 64.9709L77.984 67.5909L77.9814 66.7029L82.5193 64.083Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9023 59.024C86.6697 58.5809 87.2952 58.9344 87.2977 59.8192C87.3002 60.701 86.6787 61.7744 85.9113 62.2175C85.1439 62.6606 84.5184 62.3071 84.5159 61.4253C84.5134 60.5405 85.1349 59.4671 85.9023 59.024Z",
    fill: "#FFD06C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1929 51.1338L86.1731 56.0248L68.9504 66.0336L68.9702 61.1425L86.1929 51.1338Z",
    fill: "#4C5C75"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9701 61.1425L68.9503 66.0335L51.6113 56.0229L51.6311 51.1318L68.9701 61.1425Z",
    fill: "#1D2943"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3537 59.8926L50.3508 60.8946L67.5826 70.8433L67.5854 69.8413L50.3537 59.8926Z",
    fill: "#7F1767"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.359 57.9678L50.3562 58.9698L67.588 68.9185L67.5908 67.9165L50.359 57.9678Z",
    fill: "#7F1767"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3481 61.8135L50.3452 62.8155L67.577 72.7642L67.5798 71.7622L50.3481 61.8135Z",
    fill: "#7F1767"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8488 44.3887L88.826 52.9077L68.9578 64.4539L68.9806 55.9348L88.8488 44.3887Z",
    fill: "#7F1767"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9805 55.9351L68.9577 64.4541L48.9553 52.9058L48.9781 44.3867L68.9805 55.9351Z",
    fill: "#963880"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8488 44.3882L68.9806 55.9343L48.9783 44.386L68.8465 32.8398L88.8488 44.3882Z",
    fill: "#7F1767"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9133 44.3806L68.8494 35.1191L84.9133 44.3938L68.9772 53.655L52.9133 44.3806Z",
    fill: "#7E5AF2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5141 51.4375L82.5166 52.3254L77.9788 54.9453L77.9763 54.0574L82.5141 51.4375Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5097 49.7314L82.5123 50.6194L77.9744 53.2393L77.9719 52.3514L82.5097 49.7314Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5193 53.1387L82.5218 54.0266L77.984 56.6465L77.9814 55.7586L82.5193 53.1387Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9025 48.0797C86.6699 47.6366 87.2955 47.99 87.298 48.8749C87.3005 49.7567 86.679 50.8301 85.9116 51.2732C85.1442 51.7162 84.5186 51.3628 84.5161 50.481C84.5136 49.5961 85.1351 48.5227 85.9025 48.0797Z",
    fill: "#FFD06C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1929 40.1885L86.1731 45.0795L68.9504 55.0882L68.9702 50.1972L86.1929 40.1885Z",
    fill: "#4C5C75"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9703 50.1962L68.9506 55.0872L51.6116 45.0766L51.6313 40.1855L68.9703 50.1962Z",
    fill: "#1D2943"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3537 48.9463L50.3508 49.9483L67.5826 59.8971L67.5854 58.8951L50.3537 48.9463Z",
    fill: "#7F1767"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3588 47.0234L50.356 48.0254L67.5877 57.9742L67.5906 56.9722L50.3588 47.0234Z",
    fill: "#7F1767"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3483 50.8691L50.3455 51.8712L67.5772 61.8199L67.5801 60.8179L50.3483 50.8691Z",
    fill: "#7F1767"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8485 33.4414L88.8257 41.9605L68.9575 53.5066L68.9803 44.9875L88.8485 33.4414Z",
    fill: "#7F1767"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9805 44.9888L68.9577 53.5078L48.9553 41.9595L48.9781 33.4404L68.9805 44.9888Z",
    fill: "#963880"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8488 33.4419L68.9806 44.9881L48.9783 33.4397L68.8465 21.8936L88.8488 33.4419Z",
    fill: "#7F1767"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9133 33.4344L68.8494 24.1729L84.9133 33.4475L68.9772 42.7087L52.9133 33.4344Z",
    fill: "#7E5AF2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5144 40.4893L82.5169 41.3772L77.9791 43.9971L77.9766 43.1092L82.5144 40.4893Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5095 38.7832L82.512 39.6711L77.9742 42.291L77.9717 41.4031L82.5095 38.7832Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5193 42.1904L82.5218 43.0784L77.984 45.6983L77.9814 44.8103L82.5193 42.1904Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9023 37.1314C86.6697 36.6884 87.2952 37.0418 87.2977 37.9266C87.3002 38.8085 86.6787 39.8819 85.9113 40.3249C85.1439 40.768 84.5184 40.4146 84.5159 39.5327C84.5134 38.6479 85.1349 37.5745 85.9023 37.1314Z",
    fill: "#FFD06C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1931 29.2422L86.1734 34.1332L68.9507 44.1419L68.9704 39.2509L86.1931 29.2422Z",
    fill: "#4C5C75"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9703 39.2509L68.9506 44.1419L51.6116 34.1313L51.6313 29.2402L68.9703 39.2509Z",
    fill: "#1D2943"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3534 38.001L50.3506 39.003L67.5824 48.9517L67.5852 47.9497L50.3534 38.001Z",
    fill: "#7F1767"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3588 36.0752L50.356 37.0772L67.5877 47.026L67.5906 46.024L50.3588 36.0752Z",
    fill: "#7F1767"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3478 39.9209L50.345 40.9229L67.5767 50.8717L67.5796 49.8697L50.3478 39.9209Z",
    fill: "#7F1767"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8488 22.4971L88.826 31.0161L68.9578 42.5622L68.9806 34.0432L88.8488 22.4971Z",
    fill: "#7F1767"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9805 34.0435L68.9577 42.5625L48.9553 31.0142L48.9781 22.4951L68.9805 34.0435Z",
    fill: "#963880"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8486 22.4976L68.9804 34.0437L48.978 22.4953L68.8462 10.9492L88.8486 22.4976Z",
    fill: "#7F1767"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9133 22.49L68.8494 13.2285L84.9133 22.5032L68.9772 31.7644L52.9133 22.49Z",
    fill: "#7E5AF2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5141 29.542L82.5166 30.4299L77.9788 33.0498L77.9763 32.1619L82.5141 29.542Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5097 27.8359L82.5123 28.7239L77.9744 31.3438L77.9719 30.4558L82.5097 27.8359Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5195 31.2451L82.522 32.1331L77.9842 34.753L77.9817 33.865L82.5195 31.2451Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9025 26.1842C86.6699 25.7411 87.2955 26.0945 87.298 26.9794C87.3005 27.8612 86.679 28.9346 85.9116 29.3777C85.1442 29.8207 84.5186 29.4673 84.5161 28.5855C84.5136 27.7006 85.1351 26.6272 85.9025 26.1842Z",
    fill: "#FFD06C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1929 18.2959L86.1731 23.1869L68.9504 33.1957L68.9702 28.3046L86.1929 18.2959Z",
    fill: "#4C5C75"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9701 28.3046L68.9503 33.1956L51.6113 23.185L51.6311 18.2939L68.9701 28.3046Z",
    fill: "#1D2943"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3537 27.0537L50.3508 28.0557L67.5826 38.0045L67.5854 37.0025L50.3537 27.0537Z",
    fill: "#7F1767"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3588 25.1279L50.356 26.1299L67.5877 36.0787L67.5906 35.0767L50.3588 25.1279Z",
    fill: "#7F1767"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3483 28.9736L50.3455 29.9756L67.5772 39.9244L67.5801 38.9224L50.3483 28.9736Z",
    fill: "#7F1767"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8488 11.5488L88.826 20.0679L68.9578 31.614L68.9806 23.095L88.8488 11.5488Z",
    fill: "#7F1767"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9805 23.0943L68.9577 31.6133L48.9553 20.0649L48.9781 11.5459L68.9805 23.0943Z",
    fill: "#963880"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8488 11.5484L68.9806 23.0945L48.9783 11.5461L68.8465 0L88.8488 11.5484Z",
    fill: "#D96ABF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9133 11.5418L68.8494 2.28027L84.9133 11.5549L68.9772 20.8161L52.9133 11.5418Z",
    fill: "#A01681"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6389 22.5889L72.651 26.8846L70.5205 28.1147L70.5083 23.8189L72.6389 22.5889Z",
    fill: "#FFD06C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M75.968 20.667L75.9802 24.9628L73.957 26.1309L73.9448 21.8351L75.968 20.667Z",
    fill: "#FFD06C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5141 18.5967L82.5166 19.4846L77.9788 22.1045L77.9763 21.2166L82.5141 18.5967Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5097 16.8906L82.5123 17.7786L77.9744 20.3985L77.9719 19.5105L82.5097 16.8906Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5193 20.2979L82.5218 21.1858L77.984 23.8057L77.9814 22.9178L82.5193 20.2979Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9025 15.2379C86.6699 14.7948 87.2955 15.1482 87.298 16.0331C87.3005 16.9149 86.679 17.9883 85.9116 18.4314C85.1442 18.8744 84.5186 18.521 84.5161 17.6392C84.5136 16.7543 85.1351 15.6809 85.9025 15.2379Z",
    fill: "#FFD06C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3537 16.1074L50.3508 17.1094L67.5826 27.0582L67.5854 26.0562L50.3537 16.1074Z",
    fill: "#7F1767"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3588 14.1826L50.356 15.1846L67.5877 25.1334L67.5906 24.1314L50.3588 14.1826Z",
    fill: "#7F1767"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3483 18.0283L50.3455 19.0303L67.5772 28.9791L67.5801 27.9771L50.3483 18.0283Z",
    fill: "#7F1767"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9816 9.75543V11.8072C76.9816 12.9886 76.194 14.1907 74.6396 15.0819C71.4893 16.9057 66.3908 16.9057 63.2199 15.0819C61.624 14.17 60.8364 12.9679 60.8364 11.7657L60.8572 9.92127V9.73469C60.8572 9.75695 60.8678 9.78048 60.8683 9.803C60.8219 8.5771 61.5929 7.34223 63.1992 6.41867C66.3287 4.59482 71.4478 4.59482 74.5981 6.41867C76.194 7.33059 77.0022 8.55332 76.9816 9.75543Z",
    fill: "#FEBC1F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9847 9.75124L76.9789 11.8084C76.9755 12.9964 76.1963 14.1826 74.6371 15.0886C71.4956 16.9143 66.3805 16.9096 63.2225 15.0864C61.6329 14.1686 60.8381 12.9626 60.8416 11.7583L60.8474 9.70117C60.844 10.9055 61.6387 12.1114 63.2284 13.0292C66.3864 14.8525 71.5015 14.8571 74.643 13.0315C76.2021 12.1254 76.9814 10.9392 76.9847 9.75124Z",
    fill: "#7F1767"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6018 6.4191C77.7598 8.24237 77.7845 11.2052 74.643 13.0309C71.5015 14.8565 66.3864 14.8519 63.2284 13.0286C60.0704 11.2053 60.0497 8.24479 63.1912 6.41915C66.3327 4.59352 71.4438 4.59581 74.6018 6.4191Z",
    fill: "#D96ABF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6386 33.5352L72.6508 37.8309L70.5202 39.061L70.5081 34.7652L72.6386 33.5352Z",
    fill: "#FFD06C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9678 31.6133L75.98 35.909L73.9568 37.0771L73.9446 32.7814L75.9678 31.6133Z",
    fill: "#FFD06C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6386 33.5352L72.6508 37.8309L70.5202 39.061L70.5081 34.7652L72.6386 33.5352Z",
    fill: "#FFD06C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9678 31.6133L75.98 35.909L73.9568 37.0771L73.9446 32.7814L75.9678 31.6133Z",
    fill: "#FFD06C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6389 44.4824L72.651 48.7782L70.5205 50.0083L70.5083 45.7125L72.6389 44.4824Z",
    fill: "#FFD06C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M75.968 42.5605L75.9802 46.8563L73.957 48.0244L73.9448 43.7286L75.968 42.5605Z",
    fill: "#FFD06C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6389 44.4824L72.651 48.7782L70.5205 50.0083L70.5083 45.7125L72.6389 44.4824Z",
    fill: "#FFD06C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M75.968 42.5605L75.9802 46.8563L73.957 48.0244L73.9448 43.7286L75.968 42.5605Z",
    fill: "#FFD06C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6386 55.4297L72.6508 59.7254L70.5202 60.9555L70.5081 56.6598L72.6386 55.4297Z",
    fill: "#FFD06C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9678 53.5068L75.98 57.8026L73.9568 58.9707L73.9446 54.6749L75.9678 53.5068Z",
    fill: "#FFD06C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6386 55.4297L72.6508 59.7254L70.5202 60.9555L70.5081 56.6598L72.6386 55.4297Z",
    fill: "#FFD06C"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9678 53.5068L75.98 57.8026L73.9568 58.9707L73.9446 54.6749L75.9678 53.5068Z",
    fill: "#FFD06C"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6386 66.375L72.6508 70.6708L70.5202 71.9008L70.5081 67.6051L72.6386 66.375Z",
    fill: "#FFD06C"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9678 64.4521L75.98 68.7479L73.9568 69.916L73.9446 65.6203L75.9678 64.4521Z",
    fill: "#FFD06C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M33.521 99.9999C33.432 99.9999 33.3419 99.9766 33.2619 99.9301L13.2591 88.3823C13.0992 88.2902 13 88.1192 13 87.935C13 87.7498 13.0982 87.5788 13.2581 87.4857L33.1263 75.939C33.2852 75.8469 33.4846 75.8449 33.6455 75.939L53.6484 87.4877C53.8083 87.5798 53.9074 87.7508 53.9074 87.935C53.9074 88.1202 53.8093 88.2912 53.6494 88.3844L33.7811 99.9301C33.7011 99.9766 33.6111 99.9999 33.521 99.9999ZM14.5524 87.933L33.52 98.8827L52.3561 87.9371L33.3874 76.9864L14.5524 87.933Z",
    fill: "#4C5C75"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3212 75.9814L53.2984 84.5005L33.4302 96.0466L33.453 87.5276L53.3212 75.9814Z",
    fill: "#7F1767"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4529 87.5279L33.4301 96.0469L13.4277 84.4985L13.4505 75.9795L33.4529 87.5279Z",
    fill: "#963880"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3212 75.982L33.453 87.5281L13.4507 75.9797L33.3189 64.4336L53.3212 75.982Z",
    fill: "#7F1767"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3857 75.9744L33.3219 66.7129L49.3857 75.9876L33.4496 85.2487L17.3857 75.9744Z",
    fill: "#7E5AF2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M46.987 83.0283L46.9896 83.9162L42.4517 86.5362L42.4492 85.6482L46.987 83.0283Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9822 81.3223L46.9847 82.2102L42.4469 84.8301L42.4443 83.9422L46.9822 81.3223Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9919 84.7314L46.9944 85.6194L42.4566 88.2393L42.4541 87.3514L46.9919 84.7314Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3749 79.6724C51.1423 79.2294 51.7679 79.5828 51.7704 80.4677C51.7729 81.3495 51.1514 82.4229 50.384 82.8659C49.6166 83.309 48.991 82.9556 48.9885 82.0738C48.986 81.1889 49.6075 80.1155 50.3749 79.6724Z",
    fill: "#FFD06C"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6653 71.7803L50.6455 76.6713L33.4229 86.68L33.4426 81.789L50.6653 71.7803Z",
    fill: "#4C5C75"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4425 81.789L33.4227 86.68L16.0837 76.6694L16.1035 71.7783L33.4425 81.789Z",
    fill: "#1D2943"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8261 80.5381L14.8232 81.5401L32.055 91.4889L32.0578 90.4868L14.8261 80.5381Z",
    fill: "#7F1767"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8317 78.6133L14.8289 79.6153L32.0606 89.564L32.0635 88.562L14.8317 78.6133Z",
    fill: "#7F1767"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8207 82.459L14.8179 83.461L32.0496 93.4098L32.0525 92.4077L14.8207 82.459Z",
    fill: "#7F1767"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3214 65.0332L53.2986 73.5522L33.4304 85.0984L33.4532 76.5793L53.3214 65.0332Z",
    fill: "#7F1767"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4529 76.5796L33.4301 85.0987L13.4277 73.5503L13.4505 65.0312L33.4529 76.5796Z",
    fill: "#963880"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3215 65.0337L33.4533 76.5798L13.4509 65.0315L33.3191 53.4854L53.3215 65.0337Z",
    fill: "#7F1767"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3862 65.0261L33.3223 55.7646L49.3862 65.0393L33.4501 74.3005L17.3862 65.0261Z",
    fill: "#7E5AF2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9868 72.0811L46.9893 72.969L42.4515 75.5889L42.449 74.701L46.9868 72.0811Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9822 70.375L46.9847 71.2629L42.4469 73.8828L42.4443 72.9949L46.9822 70.375Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9919 73.7832L46.9944 74.6711L42.4566 77.291L42.4541 76.4031L46.9919 73.7832Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3749 68.7232C51.1423 68.2802 51.7679 68.6336 51.7704 69.5184C51.7729 70.4003 51.1514 71.4737 50.384 71.9167C49.6166 72.3598 48.991 72.0064 48.9885 71.1245C48.986 70.2397 49.6075 69.1663 50.3749 68.7232Z",
    fill: "#FFD06C"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6655 60.833L50.6458 65.724L33.4231 75.7328L33.4429 70.8417L50.6655 60.833Z",
    fill: "#4C5C75"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4427 70.8437L33.423 75.7347L16.084 65.724L16.1037 60.833L33.4427 70.8437Z",
    fill: "#1D2943"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8258 69.5928L14.823 70.5948L32.0548 80.5435L32.0576 79.5415L14.8258 69.5928Z",
    fill: "#7F1767"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8312 67.667L14.8284 68.669L32.0601 78.6178L32.063 77.6158L14.8312 67.667Z",
    fill: "#7F1767"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8205 71.5127L14.8176 72.5147L32.0494 82.4635L32.0522 81.4615L14.8205 71.5127Z",
    fill: "#7F1767"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3212 54.0908L53.2984 62.6099L33.4302 74.156L33.453 65.637L53.3212 54.0908Z",
    fill: "#7F1767"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4529 65.6363L33.4301 74.1553L13.4277 62.6069L13.4505 54.0879L33.4529 65.6363Z",
    fill: "#963880"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3212 54.0904L33.453 65.6365L13.4507 54.0881L33.3189 42.542L53.3212 54.0904Z",
    fill: "#7F1767"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3857 54.0828L33.3219 44.8213L49.3857 54.096L33.4496 63.3571L17.3857 54.0828Z",
    fill: "#7E5AF2"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9868 61.1357L46.9893 62.0237L42.4515 64.6436L42.449 63.7557L46.9868 61.1357Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9822 59.4297L46.9847 60.3176L42.4469 62.9375L42.4443 62.0496L46.9822 59.4297Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9917 62.8379L46.9942 63.7258L42.4564 66.3457L42.4539 65.4578L46.9917 62.8379Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3749 57.7769C51.1423 57.3339 51.7679 57.6873 51.7704 58.5722C51.7729 59.454 51.1514 60.5274 50.384 60.9704C49.6166 61.4135 48.991 61.0601 48.9885 60.1783C48.986 59.2934 49.6075 58.22 50.3749 57.7769Z",
    fill: "#FFD06C"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6653 49.8887L50.6455 54.7797L33.4229 64.7884L33.4426 59.8974L50.6653 49.8887Z",
    fill: "#4C5C75"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4425 59.8974L33.4227 64.7884L16.0837 54.7778L16.1035 49.8867L33.4425 59.8974Z",
    fill: "#1D2943"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8263 58.6465L14.8235 59.6485L32.0552 69.5973L32.0581 68.5952L14.8263 58.6465Z",
    fill: "#7F1767"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8315 56.7217L14.8286 57.7237L32.0604 67.6725L32.0632 66.6704L14.8315 56.7217Z",
    fill: "#7F1767"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8207 60.5674L14.8179 61.5694L32.0496 71.5182L32.0525 70.5161L14.8207 60.5674Z",
    fill: "#7F1767"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3214 43.1406L53.2986 51.6597L33.4304 63.2058L33.4532 54.6868L53.3214 43.1406Z",
    fill: "#7F1767"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4534 54.687L33.4306 63.2061L13.4282 51.6577L13.451 43.1387L33.4534 54.687Z",
    fill: "#963880"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3215 43.1402L33.4533 54.6863L13.4509 43.1379L33.3191 31.5918L53.3215 43.1402Z",
    fill: "#7F1767"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M17.386 43.1336L33.3221 33.8721L49.386 43.1467L33.4499 52.4079L17.386 43.1336Z",
    fill: "#7E5AF2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M46.987 50.1885L46.9896 51.0764L42.4517 53.6963L42.4492 52.8084L46.987 50.1885Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9822 48.4824L46.9847 49.3704L42.4469 51.9903L42.4443 51.1023L46.9822 48.4824Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9919 51.8896L46.9944 52.7776L42.4566 55.3975L42.4541 54.5096L46.9919 51.8896Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3749 46.8306C51.1423 46.3876 51.7679 46.741 51.7704 47.6259C51.7729 48.5077 51.1514 49.5811 50.384 50.0241C49.6166 50.4672 48.991 50.1138 48.9885 49.232C48.986 48.3471 49.6075 47.2737 50.3749 46.8306Z",
    fill: "#FFD06C"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6655 38.9385L50.6458 43.8295L33.4231 53.8382L33.4429 48.9472L50.6655 38.9385Z",
    fill: "#4C5C75"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4427 48.9472L33.423 53.8382L16.084 43.8276L16.1037 38.9365L33.4427 48.9472Z",
    fill: "#1D2943"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8261 47.6982L14.8232 48.7002L32.055 58.649L32.0578 57.647L14.8261 47.6982Z",
    fill: "#7F1767"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8317 45.7754L14.8289 46.7774L32.0606 56.7262L32.0635 55.7242L14.8317 45.7754Z",
    fill: "#7F1767"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8207 49.6211L14.8179 50.6231L32.0496 60.5719L32.0525 59.5699L14.8207 49.6211Z",
    fill: "#7F1767"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3212 32.1924L53.2984 40.7114L33.4302 52.2576L33.453 43.7385L53.3212 32.1924Z",
    fill: "#7F1767"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4526 43.7398L33.4299 52.2588L13.4275 40.7105L13.4503 32.1914L33.4526 43.7398Z",
    fill: "#963880"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3212 32.1919L33.453 43.7381L13.4507 32.1897L33.3189 20.6436L53.3212 32.1919Z",
    fill: "#D96ABF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3857 32.1853L33.3219 22.9238L49.3857 32.1985L33.4496 41.4597L17.3857 32.1853Z",
    fill: "#A01681"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1113 43.2334L37.1234 47.5292L34.9929 48.7592L34.9807 44.4635L37.1113 43.2334Z",
    fill: "#FFD06C"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4405 41.3115L40.4526 45.6073L38.4294 46.7754L38.4172 42.4796L40.4405 41.3115Z",
    fill: "#FFD06C"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9868 39.2402L46.9893 40.1282L42.4515 42.7481L42.449 41.8601L46.9868 39.2402Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9822 37.5342L46.9847 38.4221L42.4469 41.042L42.4443 40.1541L46.9822 37.5342Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9917 40.9414L46.9942 41.8293L42.4564 44.4493L42.4539 43.5613L46.9917 40.9414Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3752 35.8824C51.1426 35.4393 51.7681 35.7927 51.7706 36.6776C51.7731 37.5594 51.1516 38.6328 50.3842 39.0759C49.6168 39.519 48.9913 39.1655 48.9888 38.2837C48.9863 37.3989 49.6078 36.3255 50.3752 35.8824Z",
    fill: "#FFD06C"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8263 36.752L14.8235 37.754L32.0552 47.7027L32.0581 46.7007L14.8263 36.752Z",
    fill: "#7F1767"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8315 34.8271L14.8286 35.8292L32.0604 45.7779L32.0632 44.7759L14.8315 34.8271Z",
    fill: "#7F1767"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8207 38.6729L14.8179 39.6749L32.0496 49.6236L32.0525 48.6216L14.8207 38.6729Z",
    fill: "#7F1767"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4583 30.4V32.4519C41.4583 33.6333 40.6707 34.8352 39.1163 35.7264C35.966 37.571 30.8469 37.5503 27.6966 35.7264C26.1007 34.8145 25.3132 33.6125 25.3132 32.4104V30.3586C25.3132 29.1565 26.1007 27.9751 27.6551 27.0632C30.8054 25.2394 35.9246 25.2394 39.0748 27.0632C40.65 27.9751 41.4583 29.198 41.4583 30.4Z",
    fill: "#FEBC1F"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4579 30.3958L41.452 32.4529C41.4487 33.6409 40.6694 34.8271 39.1103 35.7332C35.9688 37.5588 30.8537 37.5542 27.6957 35.7309C26.106 34.8131 25.3113 33.6072 25.3147 32.4028L25.3205 30.3457C25.3171 31.55 26.1118 32.756 27.7015 33.6738C30.8595 35.497 35.9746 35.5017 39.1161 33.676C40.6753 32.7699 41.4545 31.5837 41.4579 30.3958Z",
    fill: "#7F1767"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0752 27.0636C42.2332 28.8869 42.2579 31.8498 39.1164 33.6754C35.9749 35.501 30.8598 35.4964 27.7018 33.6731C24.5437 31.8498 24.5231 28.8893 27.6646 27.0637C30.8061 25.238 35.9171 25.2403 39.0752 27.0636Z",
    fill: "#D96ABF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M37.112 54.1816L37.1242 58.4774L34.9936 59.7075L34.9814 55.4117L37.112 54.1816Z",
    fill: "#FFD06C"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4414 52.2607L40.4536 56.5565L38.4304 57.7246L38.4182 53.4288L40.4414 52.2607Z",
    fill: "#FFD06C"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M37.112 54.1816L37.1242 58.4774L34.9936 59.7075L34.9814 55.4117L37.112 54.1816Z",
    fill: "#FFD06C"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4414 52.2607L40.4536 56.5565L38.4304 57.7246L38.4182 53.4288L40.4414 52.2607Z",
    fill: "#FFD06C"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1122 65.1279L37.1244 69.4237L34.9939 70.6538L34.9817 66.358L37.1122 65.1279Z",
    fill: "#FFD06C"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4414 63.2061L40.4536 67.5018L38.4304 68.6699L38.4182 64.3742L40.4414 63.2061Z",
    fill: "#FFD06C"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1122 65.1279L37.1244 69.4237L34.9939 70.6538L34.9817 66.358L37.1122 65.1279Z",
    fill: "#FFD06C"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4414 63.2061L40.4536 67.5018L38.4304 68.6699L38.4182 64.3742L40.4414 63.2061Z",
    fill: "#FFD06C"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M37.112 76.0752L37.1242 80.371L34.9936 81.601L34.9814 77.3053L37.112 76.0752Z",
    fill: "#FFD06C"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4412 74.1523L40.4534 78.4481L38.4301 79.6162L38.418 75.3205L40.4412 74.1523Z",
    fill: "#FFD06C"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M37.112 76.0752L37.1242 80.371L34.9936 81.601L34.9814 77.3053L37.112 76.0752Z",
    fill: "#FFD06C"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4412 74.1523L40.4534 78.4481L38.4301 79.6162L38.418 75.3205L40.4412 74.1523Z",
    fill: "#FFD06C"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1122 87.0225L37.1244 91.3182L34.9939 92.5483L34.9817 88.2525L37.1122 87.0225Z",
    fill: "#FFD06C"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4414 85.0996L40.4536 89.3954L38.4304 90.5635L38.4182 86.2677L40.4414 85.0996Z",
    fill: "#FFD06C"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1007 98.5803C48.0106 98.5803 47.9206 98.557 47.8406 98.5104L41.9549 95.0909C41.707 94.9472 41.623 94.6295 41.7667 94.3825C41.9104 94.1326 42.2282 94.0506 42.4751 94.1943L48.1007 97.463L67.4883 86.1946C67.6472 86.1025 67.8465 86.1015 68.0075 86.1936L74.0804 89.696C74.3283 89.8397 74.4133 90.1565 74.2706 90.4044C74.1259 90.6514 73.8102 90.7333 73.5622 90.5947L67.7494 87.242L48.3608 98.5104C48.2808 98.557 48.1908 98.5803 48.1007 98.5803Z",
    fill: "#4C5C75"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M86.878 90.2482C86.79 90.2482 86.6999 90.2259 86.6189 90.1783L80.9195 86.8833C80.7596 86.7912 80.6604 86.6202 80.6604 86.435C80.6604 86.2508 80.7585 86.0798 80.9184 85.9867L92.4136 79.3258L80.6503 72.5202C80.4023 72.3775 80.3173 72.0598 80.461 71.8129C80.6057 71.5629 80.9245 71.4809 81.1684 71.6236L93.7069 78.8775C93.8678 78.9696 93.966 79.1406 93.966 79.3258C93.966 79.511 93.8678 79.681 93.7079 79.7741L82.2128 86.434L87.1371 89.2817C87.385 89.4244 87.47 89.7412 87.3263 89.9891C87.2302 90.1551 87.0561 90.2482 86.878 90.2482Z",
    fill: "#4C5C75"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5402 89.531L81.5337 90.7872C81.5272 91.7116 80.9196 92.6296 79.7107 93.3342C77.2801 94.7499 73.3174 94.7499 70.8738 93.3342C69.6327 92.6231 69.0186 91.6858 69.0186 90.7549L69.0315 89.4922L81.5402 89.531Z",
    fill: "#FFD06C"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7143 92.0754C79.2436 92.3493 78.7168 92.5741 78.1478 92.7357C77.7193 92.8692 77.2697 92.9675 76.8061 93.0307C76.5814 93.0659 76.3495 93.087 76.1178 93.101C74.8674 93.2064 73.5748 93.0799 72.4228 92.7287C71.8679 92.5671 71.3481 92.3493 70.8774 92.0754C68.4259 90.6635 68.4118 88.3664 70.8423 86.9545C71.32 86.6806 71.8539 86.4558 72.4228 86.2872C73.5678 85.943 74.8674 85.8236 76.1178 85.9219C76.3495 85.936 76.5814 85.9641 76.8061 85.9992C77.2697 86.0694 77.7193 86.1677 78.1478 86.3012C78.7028 86.4628 79.2296 86.6806 79.6932 86.9545C82.1448 88.3664 82.1588 90.6564 79.7143 92.0754Z",
    fill: "#F9A83D"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3048 92.2969C73.7808 92.2969 72.3588 91.9605 71.3005 91.3494C70.392 90.8251 69.8706 90.1518 69.8696 89.5022C69.8687 88.852 70.3649 88.2052 71.2667 87.6812C72.3203 87.0689 73.7401 86.7314 75.2644 86.7314C76.7892 86.7314 78.2138 87.0692 79.2756 87.6822C80.1793 88.2039 80.6982 88.8747 80.6992 89.5224C80.6998 90.1748 80.2014 90.8241 79.2948 91.3506C78.245 91.9608 76.8277 92.2969 75.3048 92.2969Z",
    fill: "#FFD06C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76.1173 85.9209V93.1C74.8669 93.2054 73.5744 93.0789 72.4224 92.7277V86.2862C73.5674 85.942 74.8669 85.8226 76.1173 85.9209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.1473 86.2991V92.7336C77.7188 92.8671 77.2693 92.9654 76.8057 93.0287V85.9971C77.2693 86.0673 77.7188 86.1657 78.1473 86.2991Z",
    fill: "white"
  }))), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2628 91.1042L98.2564 92.3605C98.2499 93.2849 97.6422 94.2028 96.4334 94.9074C94.0028 96.3232 90.0401 96.3232 87.5965 94.9074C86.3553 94.1963 85.7412 93.259 85.7412 92.3281L85.7542 91.0654L98.2628 91.1042Z",
    fill: "#FFD06C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M96.437 93.6477C95.9663 93.9216 95.4395 94.1464 94.8705 94.308C94.442 94.4415 93.9924 94.5398 93.5288 94.603C93.304 94.6381 93.0722 94.6592 92.8404 94.6732C91.59 94.7786 90.2975 94.6522 89.1455 94.301C88.5905 94.1394 88.0707 93.9216 87.6001 93.6477C85.1485 92.2357 85.1345 89.9387 87.565 88.5268C88.0426 88.2528 88.5765 88.028 89.1455 87.8595C90.2905 87.5152 91.59 87.3958 92.8404 87.4942C93.0722 87.5082 93.304 87.5363 93.5288 87.5714C93.9924 87.6417 94.442 87.74 94.8705 87.8735C95.4254 88.0351 95.9523 88.2528 96.4159 88.5268C98.8674 89.9387 98.8815 92.2287 96.437 93.6477Z",
    fill: "#F9A83D"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0277 93.8692C90.5037 93.8692 89.0817 93.5327 88.0234 92.9216C87.1149 92.3973 86.5935 91.7241 86.5925 91.0745C86.5916 90.4242 87.0878 89.7775 87.9896 89.2535C89.0432 88.6411 90.463 88.3037 91.9873 88.3037C93.5121 88.3037 94.9367 88.6415 95.9985 89.2544C96.9022 89.7762 97.4211 90.447 97.4221 91.0947C97.4227 91.7471 96.9243 92.3964 96.0177 92.9229C94.9679 93.533 93.5506 93.8692 92.0277 93.8692Z",
    fill: "#FFD06C"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M92.8404 87.4942V94.6732C91.59 94.7786 90.2975 94.6522 89.1455 94.301V87.8595C90.2905 87.5152 91.59 87.3958 92.8404 87.4942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M94.8705 87.8733V94.3079C94.442 94.4413 93.9924 94.5396 93.5288 94.6029V87.5713C93.9924 87.6416 94.442 87.7399 94.8705 87.8733Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalImg1);
export default __webpack_public_path__ + "static/media/professional_img1.1d6143c186c02344248dce05b6cd8cff.svg";
export { ForwardRef as ReactComponent };